define('superAdminMbAnaResView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!superAdminMbAnaResListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var MbAnaResListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'mbanaresListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteMbAnaRes: '.delete-mbanares-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteMbAnaRes': 'onDeleteMbAnaRes'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {
                type: 'mbanares',
                data: this.options.data
            };
            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteMbAnaRes: function(event){
            this.trigger('mbanares:delete', this.options.data.model.get('secId'), $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'mbanares-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code',
                        width: 30
                    }, {
                        label: _.i18n('common.txt'),
                        name: 'txt',
                        classes: 'mbanares-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'txt',
                        width: 50
                    }, {
                        label: _.i18n('mbanares.color'),
                        name: 'color',
                        classes: 'mbanares-link',
                        formatter:  this.colorFormatter,
                        search: false,
                        index: 'color'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-mbanares-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            App.navigate('superAdmin/mbanares/' + rowId + '/detail', {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = MbAnaResListView;
});
